export const get = (obj: any, path: any, defValue: any) => {
  if (!path) return undefined;
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  // Find value
  const result = pathArray.reduce(
    (prevObj: any, key: any) => prevObj && prevObj[key],
    obj
  );
  return result === undefined ? defValue : result;
};

export function isEqual(x: any, y: any): any {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y;
  return x && y && tx === 'object' && tx === ty
    ? ok(x).length === ok(y).length &&
        ok(x).every(key => isEqual(x[key], y[key]))
    : x === y;
}

export const has = (obj: any, path: any) => {
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);

  return !!pathArray.reduce(
    (prevObj: any, key: any) => prevObj && prevObj[key],
    obj
  );
};

export const set = (
  obj: object,
  path: string | string[] | null,
  value: number
) => {
  const pathArray = Array.isArray(path) ? path : path?.match(/([^[.\]])+/g);

  pathArray?.reduce((acc: any, key, i) => {
    if (acc[key] === undefined) acc[key] = {};
    if (i === pathArray.length - 1) acc[key] = value;
    return acc[key];
  }, obj);
};

export const noop = () => {};

function fromEntry(entries: any) {
  if (!entries || !entries[Symbol.iterator]) {
    throw new Error('Object.fromEntries() requires a single iterable argument');
  }
  let obj = {} as any;
  for (let [key, value] of entries) {
    obj[key] = value;
  }
  return obj;
}

export const fromPairs = (entries: any) => {
  if (!Object.fromEntries) {
    return fromEntry(entries);
  } else {
    return Object.fromEntries(entries);
  }
};

export function fromEntries(entries: any): any {
  var res: any = {};
  for (var i = 0; i < entries.length; i++) res[entries[i][0]] = entries[i][1];
  return res;
}

export const defaultTo = (a: any, b: any) =>
  a == null || Object.is(a, NaN) ? b : a;

export const toPath = (path: string) => path.match(/([^[.\]])+/g);

export const isFunction = (val: any) => typeof val === 'function';

export const isError = (err: any) => err instanceof Error;

export const isWeakMap = (value: any) =>
  value.toString() === '[object WeakMap]';

export const debounce = (func: any, delay: number) => {
  let timerId: any;

  const debounced = (...args: any[]) => {
    clearTimeout(timerId);

    timerId = setTimeout(() => func(...args), delay);
  };

  debounced.cancel = () => clearTimeout(timerId);
  return debounced;
};

export const chunk = (arr: any, chunkSize = 1, cache: any[] = []) => {
  const tmp: any = [...arr];
  if (chunkSize <= 0) return cache;
  while (tmp.length) cache.push(tmp.splice(0, chunkSize));
  return cache;
};

export const pick = (obj: any, ...keys: any) => {
  keys = keys.flat();
  const result: any = {};
  for (let key in obj) {
    if (keys.includes(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

export const mergeDeep = (obj: any, source: any, fn: any = undefined) => {
  if (isFunction(fn)) {
    for (let k of Object.keys(obj)) {
      if (!fn(obj[k], source[k])) break;
      return { [k]: fn(obj[k], source[k]) };
    }
  }
  for (let key in source) {
    if (source[key] === null) continue;
    obj[key] = replaceValue(obj[key], source[key], fn);
  }

  return obj;
};

function replaceValue(old: any, newVal: any, fn: any): any {
  if (Array.isArray(old) && Array.isArray(newVal)) {
    return newVal.map((val, i) => {
      return replaceValue(old[i], val, fn);
    });
  } else if (isObject(old) && isObject(newVal)) {
    return mergeDeep(old, newVal, fn);
  }
  return newVal;
}

function isObject(obj: object) {
  return obj && obj.constructor === Object;
}

export const startCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
